export let generateSign = (nombre, apellido1, firma) => {
  let sign = "";
  if (nombre !== "" && apellido1 !== "" && firma === "") {
    const generatedLastNames = apellido1.split(" ");
    let generatedLastName = generatedLastNames[0];
    generatedLastName =
      generatedLastName[0].toUpperCase() + generatedLastName.substring(1);
    sign = nombre[0].toUpperCase() + ". " + generatedLastName;
  }
  return sign;
};

export let loadFile = (elementId, callback) => {
  document.getElementById(elementId).src = window.URL.createObjectURL(
    document.getElementById(elementId).files[0]
  );
  let reader = new FileReader();
  reader.onload = function() {
    callback(reader.result);
  };
  reader.readAsDataURL(document.getElementById(elementId).files[0]);
};
